export default "__VITE_ASSET__B1h1DBiE__"